@if (anchor) {
  <a [id]="anchor"></a>
}
<div kb-layout="grid" [class.grid--reverse]="attributes.reverseItems">
  <section [attr.kb-grid-item-columns]="attributes.secondHeadline ? 8 : 12" class="side-container">
    @if (attributes.headline) {
      <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
    }

    <div kb-layout="grid" class="item-container" [class.grid--reverse]="attributes.reverseItems">
      @for (card of (attributes.secondHeadline ? attributes.items.slice(0, 1) : attributes.items); track card; let index = $index) {
        <ng-container [ngTemplateOutlet]="teaserTemplate" [ngTemplateOutletContext]="{index: index, card: card}"></ng-container>
      }
    </div>

  </section>

  @if (attributes.secondHeadline) {
    <section kb-grid-item-columns="4" class="side-container">
      <h2 kb-heading type="divider" [appEditorId]="editorIds?.secondHeadline">{{attributes.secondHeadline}}</h2>
      <div kb-layout="grid" class="item-container" [class.grid--reverse]="attributes.reverseItems">
        @for (card of attributes.items.slice(1); track card; let index = $index) {
          <ng-container [ngTemplateOutlet]="teaserTemplate" [ngTemplateOutletContext]="{index: index + 1, card: card}"></ng-container>
        }
      </div>
    </section>
  }
</div>

<ng-template #teaserTemplate let-index="index" let-card="card" [kbTemplateType]="teaserTemplateType">
  @if (displayModeFull(index)) {
    <section kb-card
      [attr.kb-grid-item-columns]="getTeaserColumns(index)"  [appEditorId]="card.editorId"
      class="grid--span-rows--2"
    >
      <ng-container slot="picture" [ngTemplateOutlet]="overlayFigureTemplate"></ng-container>
      <div slot="content">
        @if (card.attributes.subline) {
          <h4 kb-heading [appEditorId]="card.editorIds?.subline">{{card.attributes.subline}}</h4>
        }
        <p kb-paragraph [appEditorId]="card.editorIds?.text">{{ card.attributes.text }}</p>
        @if (card.attributes.link) {
          <a kb-standalone-link class="more-link"
            [kbRouterOrExternalLink]="card.attributes.link.attributes.url"
            [attr.target]="card.attributes.link.attributes.target"
            [appEditorId]="card.attributes.link.editorId"
          >
            @if (card.attributes.link.attributes.label) {
              {{ card.attributes.link.attributes.label }}
            } @else {
              <ng-container i18n="content teaser read more link@@2827984212740060090">Read more</ng-container>
            }
          </a>
        }
      </div>
    </section>
  } @else {
    <ng-container slot="picture" [ngTemplateOutlet]="overlayFigureTemplate"></ng-container>
  }
  <ng-template #overlayFigureTemplate>
    <figure kb-overlay-figure
      [heading]="card.attributes.headline" [headingLevel]="3"
      [link]="card.attributes.link ? {href: card.attributes.link.attributes.url, target: card.attributes.link.attributes.target} : undefined"
      [linkIcon]="displayModeFull(index) ? null : iconLink"
      [attr.kb-grid-item-columns]="getTeaserColumns(index)" kb-next-grid-row="related"
      [appEditorId]="card.editorId"
    >
      <kb-picture
        slot="picture"
        [appOgImage]="card.attributes.medium.attributes"
        [picture]="imageToPicture(card.attributes.medium.attributes, getPictureAspectRatio(index)).sources"
        [alt]="card.attributes.medium.attributes.alt"
        [rootColumns]="getRootTeaserColumns(index)"
        [variants]="[{aspectRatio: getPictureAspectRatio(index)}]"
      ></kb-picture>
    </figure>
  </ng-template>
</ng-template>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
